import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	getProductMarkerNormalAsync,
	getProductMarkerHoverAsync,
	getVideoMarkerNormalAsync,
} from '../../utils/StaticAssetManager.js';
import Marker from './Marker.jsx';
import ComposableModal from '../ui/modals/composable/ComposableModal.jsx';
import HotspotCircle from './ReactSVGHotspots/HotspotCircle';
import HotspotPlus from './ReactSVGHotspots/HotspotPlus';
import { getHotspotIconStyle } from '../../utils/StoreConfigManager.js';
import {
	getIconSVGAsync,
	createImageFromSvgString,
} from '../ui/ui-layer-panel/SVGIcons.jsx';
import TextModal from '../ui/modals/text/TextModal';
import ImageCarouselModal from '../ui/modals/image-carousel/ImageCarouselModal';
import { ModalTypes } from '../ui/modals/utils/ModalConstants';
import IFrameModal from '../ui/modals/iFrame/IFrameModal.jsx';
import { loadSvgImage } from '../visuals/HotspotVisual.jsx';
import ThreeDModal from '../ui/modals/threed-modal/ThreeDModal.jsx';

export const ModalMarkerTypes = Object.freeze({
	Image: 'image',
	Video: 'video',
});

export const MarkerImageAssets = Object.freeze({
	VideoMarker: 'https://cdn.obsess-vr.com/play-icon.svg',
	ImageMarker: 'https://cdn.obsess-vr.com/template-image-hotspot-icon.svg',
	TextMarker: 'https://cdn.obsess-vr.com/salesforce/character-head.svg',
	NFTMarker: 'https://cdn.obsess-vr.com/salesforce/NFT-Icon.svg',
	threeDMarker: 'https://cdn.obsess-vr.com/salesforce/salesforce_360.svg',
});

const nftHotspotId = '61f3308f073e5f4454b7d83f';
const deskHotspotIds = [
	'61f98807d1a9c095c90453d1',
	'61f989dd5cef7755af9e9a27',
	'61f988e72c622b5b9f712467',
	'61f9894ce6361a44a839dcd4',
	'6221224ff4e810f086e0b3cb',
];
const HandWaveMarker = 'https://cdn.obsess-vr.com/salesforce/hand-wave.svg';
const HandWaveDarkMarker =
	'https://cdn.obsess-vr.com/salesforce/hand-wave-dark.svg';

class ModalMarker extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
		this.onModalHidden = this.onModalHidden.bind(this);

		this.state = {
			isShowingModal: false,
			normalSpriteUrl: '',
			hoverSpriteUrl: '',
			svgSprite: null,
			svgSpriteString: '',
		};
		this.mounted = false;
	}

	setSVGIcon(markerIconUrl) {
		getIconSVGAsync(null, markerIconUrl)
			.then((svgString) => this.setState({ svgSpriteString: svgString }))
			.catch((error) => console.error(error));
	}

	componentDidMount() {
		switch (this.props.type) {
			case ModalMarkerTypes.Video:
				if (this.props.hotspotId === nftHotspotId) {
					this.setSVGIcon(MarkerImageAssets.NFTMarker);
				} else {
					this.setSVGIcon(MarkerImageAssets.VideoMarker);
				}
				break;
			case ModalMarkerTypes.Image:
				// TODO: import web-store-modules for svgs.
				this.setSVGIcon(MarkerImageAssets.ImageMarker);
				break;
			case ModalTypes.TextModal:
				if (deskHotspotIds.includes(this.props.hotspotId)) {
					getIconSVGAsync(null, HandWaveMarker).then((svgString) =>
						createImageFromSvgString(svgString, (canvas) => {
							const img = canvas.toDataURL('image/png');
							this.setState({ normalSpriteUrl: img });
						}),
					);
					getIconSVGAsync(null, HandWaveDarkMarker).then(
						(svgString) =>
							createImageFromSvgString(svgString, (canvas) => {
								const img = canvas.toDataURL('image/png');
								this.setState({ hoverSpriteUrl: img });
							}),
					);
				} else {
					if(this.props.hotspotId === '620f36dbe091b716a46715d4'){
						this.setState({ normalSpriteUrl: MarkerImageAssets.threeDMarker, hoverSpriteUrl: MarkerImageAssets.threeDMarker  });
					}else{
						this.setSVGIcon(MarkerImageAssets.TextMarker);
					}
				}
				break;
			default:
				getProductMarkerNormalAsync()
					.then((url) => this.setState({ normalSpriteUrl: url }))
					.catch((error) => console.error(error));
				getProductMarkerHoverAsync()
					.then((url) => this.setState({ hoverSpriteUrl: url }))
					.catch((error) => console.error(error));
				getHotspotIconStyle()
					.then((icon) => {
						const Sprite =
							icon == 'blank' ? HotspotCircle : HotspotPlus;
						this.setState({ svgSprite: Sprite });
					})
					.catch((error) => console.error(error));
				break;
		}
		this.mounted = true;
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	onClick() {
		if (!this.mounted) {
			return;
		}
		console.log(this.props.hotspotId);
		this.setState({ isShowingModal: true });
	}

	onModalHidden() {
		if (!this.mounted) {
			return;
		}
		this.setState({ isShowingModal: false });
	}

	getTextModal() {
		return (
			<TextModal
				modalContent={this.props.modalContent}
				onModalHidden={this.onModalHidden}
				primaryColor={this.props.primaryColor}
				secondaryColor={this.props.secondaryColor}
				obsessCounter={deskHotspotIds.includes(this.props.hotspotId)}
			/>
		);
	}

	getImageCarouselModal() {
		return (
			<ImageCarouselModal
				modalContent={this.props.modalContent}
				onModalHidden={this.onModalHidden}
				primaryColor={this.props.primaryColor}
				secondaryColor={this.props.secondaryColor}
			/>
		);
	}

	getComposableModal() {
		return (
			<ComposableModal
				type={this.props.type}
				modalContent={this.props.modalContent}
				onModalHidden={this.onModalHidden}
			/>
		);
	}

	getIFrameModal() {
		return (
			<IFrameModal
				modalContent={this.props.modalContent}
				onModalHidden={this.onModalHidden}
				primaryColor={this.props.primaryColor}
				secondaryColor={this.props.secondaryColor}
			/>
		);
	}

	getThreeDModal = () => {
		return (
			<ThreeDModal
				onModalHidden={this.onModalHidden}
				modalContent={this.props.modalContent}
			/>
		);
	};

	renderModal() {
		const { hotspotId } = this.props;
		if (this.state.isShowingModal && this.props.type) {
			switch (this.props.type) {
				case ModalTypes.TextModal:
					if (hotspotId === '620f36dbe091b716a46715d4')
						return this.getThreeDModal();
					else return this.getTextModal();
				case ModalTypes.ImageCarousel:
					return this.getImageCarouselModal();
				case ModalTypes.IFrameModal:
					return this.getIFrameModal();
				default:
					return this.getComposableModal();
			}
		}
		return null;
	}

	render() {
		const { normalSpriteUrl, hoverSpriteUrl, svgSprite, svgSpriteString } =
			this.state;
		const { fileName } = this.props;
		return (
			<div>
				{this.renderModal()}
				<Marker
					transform={this.props.transform}
					colliderTransform={this.props.colliderTransform}
					normalSpriteUrl={normalSpriteUrl}
					hoverSpriteUrl={hoverSpriteUrl}
					svgSprite={svgSprite}
					svgSpriteString={svgSpriteString}
					showVisual={this.props.showVisual}
					onClick={this.onClick}
					primaryColor={this.props.primaryColor}
					secondaryColor={this.props.secondaryColor}
					alt={fileName ? fileName : ''}
				/>
			</div>
		);
	}
}

ModalMarker.propTypes = {
	transform: PropTypes.array.isRequired,
	colliderTransform: PropTypes.array.isRequired,
	type: PropTypes.string.isRequired,
	modalContent: PropTypes.object.isRequired,
	showVisual: PropTypes.bool,
	primaryColor: PropTypes.string,
	secondaryColor: PropTypes.string,
};

export default ModalMarker;
